import { z } from "zod";
import { SessionMode } from "./websocket";
/**
 * Session metadata (flexible object for additional info)
 */
export const sessionMetadataSchema = z
    .record(z.string(), z.unknown())
    .optional();
/**
 * Session schema for database
 */
export const sessionSchema = z.object({
    id: z.string().uuid(),
    assistant_id: z.string().uuid(),
    user_id: z.string(),
    mode: z.nativeEnum(SessionMode),
    is_closed: z.boolean(),
    country: z.string().optional(),
    city: z.string().optional(),
    region: z.string().optional(),
    timezone: z.string().optional(),
    ip_address: z.string().optional(),
    user_agent: z.string().optional(),
    metadata: sessionMetadataSchema,
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
